export function getIframeVisibleCenter(): number {
  try {
    const { parent } = window
    if (parent && parent !== window) {
      const iframe = window.frameElement as HTMLElement
      if (iframe) {
        const iframeRect = iframe.getBoundingClientRect()
        const parentVH = parent.innerHeight
        const visibleTop = Math.max(0, -iframeRect.top)
        const visibleBottom = Math.min(
          iframe.clientHeight,
          -iframeRect.top + parentVH
        )
        return (visibleTop + visibleBottom) / 2
      }
    }
  } catch {
    // cross-origin
  }
  return window.innerHeight / 2
}
